import request from '@/libs/request';
import config from '@/config';
const baseUrl = config.api_base;

/**
 * 新增客户
 * @param {*} params
 * @returns
 */
export const CustomerAdd = params => {
  return request('post', `${baseUrl}/api/auth/sys/customer/add`, params);
};

/**
 * 添加用户到给定的客户{apiNoUse}
 * @param {*} data
 * @returns
 */
export const CustomerAuth = data => {
  return request('post', `${baseUrl}/api/auth/sys/customer/auth`, data);
};

/**
 * 从该客户移除已授权的用户{apiNoUse}
 * @param {*} data
 * @returns
 */

export const CustomerAuthDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/customer/auth/del`, data);
};

/**
 * 删除客户
 * @param {*} data
 * @returns
 */
export const CustomerDelete = data => {
  return request('post', `${baseUrl}/api/auth/sys/customer/del`, data);
};

/**
 * 客户详情
 * @param {*} data
 * @returns
 */

export const CustomerDetail = params => {
  return request('get', `${baseUrl}/api/auth/sys/customer/detail`, params);
};

/**
 * 编辑客户
 * @param {*} data
 * @returns
 */
export const CustomerEdit = data => {
  return request('post', `${baseUrl}/api/auth/sys/customer/edit`, data);
};

/**
 * 客户信息{apiNoUse}
 * @param {*} params
 * @returns
 */

export const CustomerInfo = params => {
  return request('get', `${baseUrl}/api/auth/sys/customer/info`, params);
};

/**
 * 客户列表
 * @param {*} params
 * @returns
 */

export const CustomerList = params => {
  return request('get', `${baseUrl}/api/auth/sys/customer/page`, params);
};

/**
 * 获取所有客户
 * @param {*} params
 * @returns
 */

export const CustomerSelect = params => {
  return request('get', `${baseUrl}/api/auth/sys/customer/select`, params);
};

/**
 * 模糊查询用户{apiNoUse}
 * @param {*} data
 * @returns
 */
export const CustomerFindUser = data => {
  return request('get', `${baseUrl}/api/auth/sys/customer/user`, data);
};
